export const PERMISSION_NAMES = {
  aiModels: "ai-models",
  aliases: "aliases",
  users: "users",
  permissions: "permissions",
  roles: "roles",
  drsPipe: "drsPipe",
  dashboard: "dashboard",
  swagger: "swagger",
  uiremoteConcat: "uiremote",
  uiremoteMobile: "uiremote-mobile",
  uiremoteDesktop: "uiremote-desktop",
  apiKeys: "api-keys",
};

export const PERMISSIONS = {
  aiModels: {
    modelsView: "model:view",
    modelsEdit: "model:edit",
    modelsTesting: "model:testing",
    ovsTesting: "ovs:testing",
  },
  aliases: {
    aliasesView: "aliases:view",
    aliasesEdit: "aliases:edit",
    keywordsView: "keywords:view",
    keywordsEdit: "keywords:edit",
  },
  users: {
    usersView: "users:view",
    usersEdit: "users:edit",
    usersAdd: "users:add",
  },
  permissions: {
    permissionsAdd: "permissions:add",
    permissionsEdit: "permissions:edit",
    permissionsView: "permissions:view",
  },
  roles: {
    rolesAdd: "roles:add",
    rolesEdit: "roles:edit",
    rolesView: "roles:view",
  },
  drsPipe: {
    pipelineView: "pipeline:view",
    pipelineEdit: "pipeline:edit",
    pipelineAdd: "pipeline:add",
    pipelineOperator: "pipeline:operator",
  },
  dashboard: {
    dashboardLogs: "dashboard:logs",
  },
  swagger: {
    swaggerView: "swagger:view",
  },
  uiremoteMobile: {
    listView: "list:view",
    listEdit: "list:edit",
  },
  uiremoteDesktop: {
    listView: "list:view",
    listEdit: "list:edit",
    processExecute: "process:execute",
    processEdit: "process:edit",
  },
  apiKeys: {
    view: "api-keys:view",
    edit: "api-keys:edit",
  },
};
